<template>
	<div class="content__column content__column--small" v-if="item">
		<h1 class="content__title">Editar Item</h1>
		<form class="form" @submit.prevent="saveItem">
			<div class="fom__fieldset">
				<p class="form__text">Existencia actual {{ newStock }}</p>
				<div class="form__container">
					<label for="stock" class="form__label">Cantidad Surtida (Esta se sumará en el sistema a la cantidad ya existente.)</label>
					<input type="text" class="form__input" name="stock" id="stock" v-model="item.stock" v-validate="validation.stock" placeholder="0" />
					<span v-show="errors.has('stock')" class="form__alert" v-text="errors.first('stock')"></span>
				</div>

				<div class="form__container">
					<label for="sku" class="form__label">SKU</label>
					<input type="text" class="form__input" name="sku" id="sku" v-model="item.sku" v-validate="validation.sku" />
					<span v-show="errors.has('sku')" class="form__alert" v-text="errors.first('sku')"></span>
				</div>

				<div class="form__container">
					<label class="form__label form__label--required" for="color_id">Color</label>
					<div class="form__select-container">
						<select name="color_id" id="color_id" class="form__select" v-validate="validation.color_id" v-model="item.color_id" @change="itemExist">
							<option hidden :value="null">Seleccione un color</option>
							<option v-for="(color, index) in colors" :key="index" :value="color.id" v-text="color.name_es"></option>
						</select>
					</div>
					<span v-show="errors.has('color_id')" class="form__alert" v-text="errors.first('color_id')"></span>
				</div>

				<div class="form__container">
					<label class="form__label form__label--required" for="size_id">Tamaño</label>
					<div class="form__select-container">
						<select name="size_id" id="size_id" class="form__select" v-validate="validation.size_id" v-model="item.size_id" @change="itemExist">
							<option hidden :value="null">Seleccione un tamaño</option>
							<option v-for="(size, index) in sizes" :key="index" :value="size.id" v-text="size.name_es"></option>
						</select>
					</div>
					<span v-show="errors.has('size_id')" class="form__alert" v-text="errors.first('size_id')"></span>
				</div>

				<div class="form__container">
					<label class="form__label form__label--required" for="status_id"> Estatus del Item</label>
					<div class="form__select-container">
						<select name="status_id" id="status_id" class="form__select" v-validate="validation.status_id" v-model="item.status_id">
							<option hidden :value="null">Seleccione un estatus</option>
							<option v-for="(status, index) in item_status" :key="index" :value="status.id" v-text="status.name"></option>
						</select>
					</div>
					<span v-show="errors.has('status_id')" class="form__alert" v-text="errors.first('status_id')"></span>
				</div>

				<div class="form__container form__container--thumbs" v-if="images && images.length > 0">
					<item-image @remove="removeImage(index)" v-for="(image, index) in images" :key="index" v-model="images[index]"></item-image>
				</div>
				<button v-if="item.color_id > 0" @click.prevent="images.push({})" class="btn btn__action btn--regular">Agregar nueva imagen</button>
				<br /><br />
			</div>
			<input type="submit" class="btn btn__action btn--regular" value="Guardar" />
			<button @click.prevent="$emit('new')" class="btn btn__transparent btn--regular">Agregar Nuevo Item</button>
		</form>
	</div>
</template>

<script>
	import httpService from '@/core/api/request'
	import { item_status } from './mocks'
	import { config } from '@/core/config/base'
	import Mixins from './mixins'
	import itemImage from './image'
	export default {
		props: {
			item: {
				type: Object,
				required: false,
				default: function() {
					return {
						id: null,
						color_id: null,
						size_id: null,
						quantity: 0,
						stock: 0,
						status_id: null,
						product_id: null,
						images: null,
						images_row_id: null,
						sku: null
					}
				}
			}
		},
		mixins: [httpService, Mixins],
		components: { itemImage },
		data: function() {
			return {
				images: [],
				item_status: item_status,
				newStock: 0,
				validation: {
					color_id: 'required|min_value:1|max:11|numeric',
					size_id: 'required|min_value:1|max:11|numeric',
					status_id: 'required|min_value:1|max:4',
					stock: 'min_value:0|max:11|numeric',
					product_id: 'required|min_value:1|max:11|numeric',
					sku: 'max:45'
				}
			}
		},
		created: function() {
			if (!this.$route.params.id) {
				this.$router.push({ name: 'inventoryView' })
			}
			this.item.product_id = this.$route.params.id
			this.getColors()
			this.getSizes()
			this.setImages()
			this.newStock = this.item.quantity
		},
		watch: {
			'item.color_id': {
				handler: function() {
					if (this.item.color_id) {
						this.images = []
						this.getProductImages()
					}
				},
				deep: true
			},
			'item.stock': function() {
				this.newStock = this.item.quantity + (!isNaN(parseInt(this.item.stock)) ? parseInt(this.item.stock) : 0)
			}
		},
		methods: {
			getProductImages: function() {
				let httpRequest = {
					module: 'product_images',
					params: '?fields=images,id&attr_id=eq:' + this.item.color_id + '&product_id=eq:' + this.item.product_id
				}
				this.get(httpRequest)
					.then(response => {
						this.images = JSON.parse(response.data[0].images)
						this.item.images_row_id = response.data[0].id
					})
					.catch(() => {
						this.images = []
					})
			},
			saveItem: function() {
				let imgs = []
				this.images.forEach(image => {
					if (image && typeof image === 'object') {
						imgs.push(image)
					}
				})
				this.item.images = imgs
				this.$validator.validateAll().then(result => {
					if (result) {
						let httpRequest = {
							params: '',
							module: 'inventory',
							element: this.item
						}
						let action
						if (this.item.id) {
							action = this.put(this.item.id, httpRequest)
						} else {
							action = this.post(httpRequest)
						}
						action
							.then(response => {
								if (!this.item.id) {
									this.item.id = response.data.current_id
								}
								this.$store.commit('elementChanged', {
									module: 'itemEdit',
									time: Math.round(new Date().getTime() / 1000)
								})
								this.$store.commit('notificate', {
									title: 'ITEM GUARDADO',
									text: 'El item ha sido guardado correctamente',
									type: 'success'
								})
							})
							.catch(() => {
								this.$store.commit('notificate', {
									title: 'ITEM NO GUARDADO',
									text: 'El item no ha sido guardado, por favor, intente más tarde',
									type: 'error'
								})
							})
					}
				})
			},
			setImages: function() {
				if (this.item && this.item.images) {
					this.images = JSON.parse(this.item.images)
				} else {
					this.images = []
				}
			},
			itemExist: function() {
				if (this.item.color_id && this.item.size_id && !this.item.id) {
					let httpRequest = {
						params: '?fields=id&product_id=eq:' + this.item.product_id  + '&color_id=eq:' + this.item.color_id + '&size_id=eq:' + this.item.size_id,
						module: 'inventory'
					}
					this.get(httpRequest).then(i => {
						this.$parent.$emit('edit', i.data[0].id)
					})
				}
			},
			removeImage: function(key) {
				this.images.splice(key, 1)
			}
		}
	}
</script>

<style lang="sass">
	@import "../../assets/sass/components/_forms"
</style>



// WEBPACK FOOTER //
// src/components/inventory/edit.vue